<template lang="pug">
section
  .dflex.editor
    .dflex-item
      .slick-container
        .sort-cn
          .sort-el.block(
            v-for='(block, index) in blocks',
            :data-index='index',
            :key='index'
          )
            .block
              div(:class='{ inner: true, "inner-ex": block.type === "table" }')
                v-tooltip(left)
                  div(slot='activator')
                    component(
                      :is='getBlock(block)',
                      :block='block',
                      @update='updateBlock'
                    )
                  | {{ getParent(block).title }}
                .remove-block
                  v-tooltip(top)
                    v-btn(
                      icon,
                      slot='activator',
                      @click.stop='removeBlock(index)'
                    )
                      v-icon(small, color='error') delete_outline
                    | Удалить блока
                .move-up
                  v-tooltip(top)
                    v-btn(
                      icon,
                      slot='activator',
                      :disabled='index === 0',
                      @click.stop='moveBlockUp(index, block)'
                    )
                      v-icon(small) arrow_upward
                    | Переместить вверх
                .move-down
                  v-tooltip(top)
                    v-btn(
                      icon,
                      slot='activator',
                      :disabled='index === blocks.length - 1',
                      @click.stop='moveBlockDown(index, block)'
                    )
                      v-icon(small) arrow_downward
                    | Переместить вниз
                .json-edit
                  v-tooltip(top)
                    v-btn(
                      icon,
                      slot='activator',
                      @click.stop='jsonEditBlock(block)'
                    )
                      v-icon(small) code
                    | JSON схема

    .dflex-auto.blocks
      blocks-list(@click='addBlock')
    v-dialog(v-model='jsonEditor', width='600')
      v-card
        .jsoneditor-container(ref='jsonEdit')
        v-card-actions
          v-spacer
          v-btn(flat, @click='closeJsonEditor') Отмена
          v-btn(color='primary', flat, @click='saveJsonChanges') Сохранить
</template>
<script>
// Блоки
import Image from './blocks/Image'
// TODO: потом удалить их
import H1 from './blocks/H1'
import H2 from './blocks/H2'
import Video from './blocks/Video'
import Link from './blocks/Link'
// eof TODO: потом удалить их
import Text from './blocks/Text'
import Quote from './blocks/Quote'
import TextWithLeftImage from './blocks/TextWithLeftImage'
import TextWithRightImage from './blocks/TextWithRightImage'
import List from './blocks/List'
import Gallery from './blocks/Gallery'
import Banner from './blocks/Banner'
import LeadForm from './blocks/LeadForm'
import SearchForm from './blocks/SearchForm'
import Heading from './blocks/Heading'
import MultiColumnText from './blocks/MultiColumnText'
import Table from './blocks/Table'
// Меню блоков
import BlocksList from './BlocksList'
import { cloneDeep } from 'lodash'

// TODO: потом удалить их
import JSONEditor from 'jsoneditor'
import 'jsoneditor/dist/jsoneditor.min.css'

export default {
  props: {
    blocksList: {
      type: Array,
      default: () => [],
    },
  },

  components: { BlocksList },

  data: function () {
    return {
      blocks: [...this.blocksList],
      jsonEditor: false,
      jsonBlock: null,
    }
  },

  mounted() {},

  methods: {
    getParent(block) {
      const blocks = require('@/enums/blocks').blocks.list
      return blocks.find((b) => b.struct.type === block.type) || {}
    },

    addBlock(block) {
      const b = cloneDeep(block)

      this.blocks.push(b.struct)
      this.$emit('change', this.blocks)

      setTimeout(() => {
        const scrollingElement = document.scrollingElement || document.body
        scrollingElement.scrollTop = scrollingElement.scrollHeight
      })
    },

    moveBlockUp(index) {
      if (index > 0) {
        const blocks = [...this.blocks]
        this.blocks = []
        // TODO: fix
        this.$nextTick(() => {
          this.blocks = arraymove(blocks, index, index - 1)
          this.$emit('change', this.blocks)
        })
      }
    },

    moveBlockDown(index) {
      if (index < this.blocks.length - 1) {
        const blocks = [...this.blocks]
        this.blocks = []
        // TODO: fix
        this.$nextTick(() => {
          this.blocks = arraymove(blocks, index, index + 1)
          this.$emit('change', this.blocks)
        })
      }
    },

    removeBlock(index) {
      this.$confirm('Удалить блок?').then((ok) => {
        if (ok) {
          this.blocks.splice(index, 1)
          this.$emit('change', this.blocks)
        }
      })
    },

    updateBlock(block) {
      const index = this.blocks.indexOf(block)
      if (-1 !== index) {
        this.blocks[index] = block
        this.$emit('change', this.blocks)
      }
    },

    // TODO: это говно нужно удалить
    jsonEditBlock(block) {
      this.jsonEditor = true
      this.$nextTick(() => {
        if (!this.editor) {
          this.editor = new JSONEditor(this.$refs.jsonEdit, {})
        }
        this.jsonBlock = block
        this.editor.set(this.jsonBlock.meta)
      })
    },
    saveJsonChanges() {
      const block = this.editor.get()
      this.jsonBlock.meta = block
      this.updateBlock(this.jsonBlock)
      this.closeJsonEditor()
    },
    closeJsonEditor() {
      this.jsonEditor = false
      this.jsonBlock = null
    },
    // EOF

    getBlock({ type }) {
      switch (type) {
        case 'image':
          return Image
        case 'text':
          return Text
        case 'quote':
          return Quote
        case 'textWithLeftImage':
          return TextWithLeftImage
        case 'textWithRightImage':
          return TextWithRightImage
        case 'list':
          return List
        case 'gallery':
          return Gallery
        case 'banner':
          return Banner
        case 'leadForm':
          return LeadForm
        case 'searchForm':
          return SearchForm
        case 'heading':
          return Heading
        case 'multiColumnText':
          return MultiColumnText
        case 'table':
          return Table
        case 'h1':
          return H1
        case 'h2':
          return H2
        case 'link':
          return Link
        case 'video':
          return Video
      }
    },
  },
}

function arraymove(arr, fromIndex, toIndex) {
  const newArr = [...arr]
  const element = newArr[fromIndex]
  newArr.splice(fromIndex, 1)
  newArr.splice(toIndex, 0, element)
  return newArr
}
</script>

<style scoped lang="scss">
.inner {
  min-height: 110px;
  position: relative;
  background: white;
  border-radius: 3px;
  padding: 12px 24px;
  border: solid 1px rgb(196, 196, 196);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.06);
}
.inner-ex {
  padding: 0;
}
.block {
  margin-bottom: 12px;
  padding-right: 60px;
  &:hover {
    .json-edit,
    .remove-block,
    .move-up,
    .move-down {
      opacity: 1;
    }
  }
}
.remove-block,
.move-up,
.move-down,
.json-edit {
  top: -6px;
  right: -60px;
  position: absolute;
  opacity: 0;
  transition: 0.25s;
}
.move-up {
  top: 0px;
}
.move-down {
  top: 32px;
}
.json-edit {
  top: 64px;
  right: -102px;
}
.remove-block {
  top: 64px;
}
.pre {
  width: 100%;
  overflow: hidden;
  white-space: pre-wrap;
}
</style>
<style scoped>
.editor >>> .v-messages {
  display: none;
}
/*
.editor >>> .v-input__slot:before,
.editor >>> .v-input__slot:after {
  visibility: hidden;
}
*/
.editor >>> textarea {
  resize: none;
}
.editor >>> .ck-focused {
  box-shadow: none !important;
  border-color: rgb(196, 196, 196) !important;
}
.jsoneditor-container >>> .jsoneditor {
  border: 0 !important;
}
.jsoneditor-container >>> .jsoneditor-menu {
  background: #27ae60;
  border-color: #27ae60;
}
</style>
